
export default {
  // Navigation
  nav_home: "Início",
  nav_intro: "Introdução",
  nav_components: "Componentes",
  nav_operation: "Funcionamento",
  nav_problems: "Problemas",
  nav_diagnosis: "Diagnóstico",
  nav_engineer: "Engenheiro",
  nav_safety: "Segurança",
  nav_electrical: "Comutação Elétrica",
  nav_quiz1: "Quiz 1",
  nav_quiz2: "Quiz 2",
  nav_quiz3: "Quiz 3",
  nav_quiz_logistiek: "Quiz Logística",

  // Home Page
  home_title: "Sistemas Logísticos Automatizados",
  home_subtitle: "Formação profissional para sistemas BEUMER Group",
  home_welcome: "Bem-vindo ao curso",
  home_description: "Este curso aborda sistemas logísticos automatizados utilizados na PostNL, DHL, Bol.com e aeroportos. Aprenda sobre transporte, triagem, leitura de códigos de barras e manutenção.",
  home_start: "Iniciar o curso",
  home_modules: "Módulos do curso",
  home_quizzes: "Teste os seus conhecimentos",

  // Introduction Page
  intro_title: "Introdução aos Sistemas Logísticos Automatizados",
  intro_description: "Os sistemas logísticos automatizados são utilizados na PostNL, DHL, Bol.com e aeroportos. Estes sistemas proporcionam:",
  intro_feature1: "Transporte de encomendas",
  intro_feature2: "Triagem automática",
  intro_feature3: "Leitura de códigos de barras",
  intro_feature4: "Distribuição para o destino correto",
  intro_feature5: "Monitorização contínua",
  intro_beumer: "O BEUMER Group projeta, constrói e mantém estes sistemas.",

  // Components Page
  comp_title: "Componentes Principais de um Sistema Logístico",
  comp_conveyor: "Transportador",
  comp_conveyor_desc: "O transportador move automaticamente as encomendas.",
  comp_conveyor_parts: "Componentes importantes:",
  comp_motor: "Motor",
  comp_inverter: "Inversor/drive",
  comp_rollers: "Rolos",
  comp_bearings: "Rolamentos",
  comp_belt: "Correia",
  comp_sensors: "Sensores",
  comp_safety: "Proteções de segurança",
  comp_plc_control: "Controlo PLC",
  
  comp_plc_title: "O que é um PLC?",
  comp_plc_def: "Um PLC (Programmable Logic Controller) é o computador que controla todo o sistema.",
  comp_plc_functions: "Funções do PLC:",
  comp_plc_func1: "Recebe sinais dos sensores",
  comp_plc_func2: "Controla motores e atuadores",
  comp_plc_func3: "Processa códigos de erro",
  comp_plc_func4: "Regula a velocidade da correia",
  comp_plc_func5: "Gere segurança e paragens de emergência",
  comp_plc_func6: "Coordena o sistema completo de triagem",
  comp_plc_note: "Sem um PLC, o sistema não funciona.",

  comp_sensors_title: "Sensores",
  comp_sensors_desc: "Sensores comumente utilizados:",
  comp_sensor1: "Fotocélula → deteta encomenda",
  comp_sensor2: "Sensor de proximidade → deteta metal",
  comp_sensor3: "Scanner de código de barras → lê etiquetas",
  comp_sensor4: "Scanner laser → mede tamanho/posição",
  comp_sensor5: "Sensores de paragem de emergência",
  comp_sensors_note: "Os sensores transmitem informação ao PLC.",

  comp_motors_title: "Motores e Drives",
  comp_motor_desc: "Motor: proporciona o movimento da correia.",
  comp_drive_desc: "Drive (inversor): controla velocidade, direção e torque.",

  comp_mechanical_title: "Componentes Mecânicos",
  comp_mech1: "Rolos",
  comp_mech2: "Rolamentos",
  comp_mech3: "Sistema de acionamento",
  comp_mech4: "Tensão da correia",
  comp_mech5: "Guias",
  comp_mech6: "Estrutura e chassis",
  comp_mech_note: "O desgaste mecânico é normal → a manutenção regular é essencial.",

  // Operation Page
  oper_title: "Funcionamento do Sistema",
  oper_subtitle: "Processo passo a passo",
  oper_step1: "Sensor deteta uma encomenda",
  oper_step2: "PLC recebe o sinal",
  oper_step3: "Motor arranca → correia move-se",
  oper_step4: "Scanner lê o código de barras",
  oper_step5: "PLC determina a rota",
  oper_step6: "Mecanismo de triagem direciona a encomenda para a saída correta",
  oper_step7: "Sistema monitoriza erros e segurança",

  // Problems Page
  prob_title: "Problemas Comuns e Soluções",
  prob_jammed: "Encomenda Encravada",
  prob_jammed_cause: "Causa: encomenda está torta ou fisicamente presa.",
  prob_jammed_solution: "Solução:",
  prob_jammed_sol1: "Parar a máquina com segurança",
  prob_jammed_sol2: "Remover a encomenda",
  prob_jammed_sol3: "Realizar inspeção",
  prob_jammed_sol4: "Reiniciar o sistema",

  prob_sensor: "Avaria do Sensor",
  prob_sensor_cause: "Causa: sensor sujo, deslocado, cabo solto.",
  prob_sensor_solution: "Solução:",
  prob_sensor_sol1: "Limpar o sensor",
  prob_sensor_sol2: "Fixar os cabos",
  prob_sensor_sol3: "Alinhar o sensor corretamente",
  prob_sensor_sol4: "Realizar teste no display",

  prob_mechanical: "Avaria Mecânica",
  prob_mech_examples: "Exemplos:",
  prob_mech_ex1: "Correia muito solta ou torta",
  prob_mech_ex2: "Rolo defeituoso",
  prob_mech_ex3: "Rolamento gasto",
  prob_mech_ex4: "Acionamento a fazer ruído",
  prob_mech_solution: "Solução:",
  prob_mech_sol1: "Verificar tensão da correia",
  prob_mech_sol2: "Substituir rolos",
  prob_mech_sol3: "Lubrificar ou renovar rolamentos",

  prob_electrical: "Avaria Elétrica",
  prob_elec_examples: "Exemplos:",
  prob_elec_ex1: "Fusível queimado",
  prob_elec_ex2: "Cabo partido",
  prob_elec_ex3: "Motor sem alimentação",
  prob_elec_ex4: "Ligações soltas",
  prob_elec_solution: "Solução:",
  prob_elec_sol1: "Realizar medição de tensão",
  prob_elec_sol2: "Verificar fusíveis",
  prob_elec_sol3: "Inspecionar cabos e conectores",

  prob_plc: "Avaria do PLC ou Software",
  prob_plc_examples: "Exemplos:",
  prob_plc_ex1: "Código de erro no ecrã do PLC",
  prob_plc_ex2: "Sensor sem sinal",
  prob_plc_ex3: "Falhas de comunicação",
  prob_plc_solution: "Solução:",
  prob_plc_sol1: "Ler código de erro",
  prob_plc_sol2: "Realizar reset",
  prob_plc_sol3: "Verificar estado do sensor/motor",
  prob_plc_sol4: "Chamar engenheiro de serviço se necessário",

  // Diagnosis Page
  diag_title: "Procedimento de Diagnóstico",
  diag_subtitle: "Abordagem profissional",
  diag_step1: "Manter a calma",
  diag_step2: "Ler código de erro no display",
  diag_step3: "Inspeção visual",
  diag_step4: "Testar sensores",
  diag_step5: "Verificar motor e correia",
  diag_step6: "Reiniciar o sistema com segurança",
  diag_step7: "Documentar a causa",
  diag_step8: "Tomar ação preventiva",

  // Engineer Page
  eng_title: "O Papel de um Site Engineer",
  eng_description: "Um Site Engineer é responsável por:",
  eng_resp1: "Continuidade do processo",
  eng_resp2: "Resolução de problemas",
  eng_resp3: "Manutenção preventiva",
  eng_resp4: "Comunicação com operadores",
  eng_resp5: "Execução de procedimentos de segurança",
  eng_resp6: "Trabalho elétrico e mecânico básico",
  eng_resp7: "Trabalho por turnos",
  eng_resp8: "Trabalho seguro (VCA)",
  eng_qualities: "Qualidades importantes:",
  eng_qual1: "Calmo",
  eng_qual2: "Preciso",
  eng_qual3: "Consciente da segurança",
  eng_qual4: "Resolução de problemas",
  eng_qual5: "Desejo de aprender",
  eng_qual6: "Colaborativo",

  // Safety Page
  safety_title: "Trabalho Seguro",
  safety_subtitle: "Aspeto mais importante",
  safety_description: "Trabalho seguro significa:",
  safety_rule1: "Sempre desligar a energia",
  safety_rule2: "\"Medir para ter certeza\": testar tensão",
  safety_rule3: "Usar EPI",
  safety_rule4: "Aplicar Lock-out / Tag-out",
  safety_rule5: "Nunca trabalhar sob pressão",
  safety_rule6: "Reconhecer riscos",

  // Quiz Common
  quiz_submit: "Submeter",
  quiz_retry: "Tentar novamente",
  quiz_score: "A sua pontuação:",
  quiz_correct: "corretas de",
  quiz_excellent: "Excelente! Dominou bem a matéria.",
  quiz_good: "Muito bem! Tem os conceitos básicos.",
  quiz_review: "Reveja o curso novamente e tente mais uma vez.",

  // Quiz 1 - Fundamentos
  quiz1_title: "Quiz 1: Fundamentos",
  quiz1_q1: "Qual é a função principal de um sistema logístico automatizado?",
  quiz1_q1_a: "Triar encomendas manualmente",
  quiz1_q1_b: "Transporte e triagem automática de encomendas",
  quiz1_q1_c: "Apenas ler códigos de barras",
  
  quiz1_q2: "Que empresas utilizam sistemas logísticos automatizados?",
  quiz1_q2_a: "Apenas PostNL",
  quiz1_q2_b: "PostNL, DHL, Bol.com e aeroportos",
  quiz1_q2_c: "Apenas aeroportos",

  quiz1_q3: "O que faz o BEUMER Group?",
  quiz1_q3_a: "Apenas manutenção",
  quiz1_q3_b: "Projetar, construir e manter sistemas logísticos",
  quiz1_q3_c: "Apenas desenvolver software",

  quiz1_q4: "O que é um transportador?",
  quiz1_q4_a: "Um carrinho manual",
  quiz1_q4_b: "Um sistema que move encomendas automaticamente",
  quiz1_q4_c: "Um espaço de armazenamento",

  quiz1_q5: "O que significa PLC?",
  quiz1_q5_a: "Centro Logístico de Encomendas",
  quiz1_q5_b: "Programmable Logic Controller",
  quiz1_q5_c: "Computador de Entrega Postal",

  quiz1_q6: "Qual é a função de um PLC?",
  quiz1_q6_a: "Apenas pesar encomendas",
  quiz1_q6_b: "Controlar e coordenar todo o sistema",
  quiz1_q6_c: "Apenas imprimir códigos de barras",

  quiz1_q7: "Que sensor deteta uma encomenda na correia?",
  quiz1_q7_a: "Sensor de temperatura",
  quiz1_q7_b: "Fotocélula",
  quiz1_q7_c: "Sensor de pressão",

  quiz1_q8: "O que lê um scanner de código de barras?",
  quiz1_q8_a: "Temperatura",
  quiz1_q8_b: "Etiquetas nas encomendas",
  quiz1_q8_c: "Peso",

  // Quiz 2 - Componentes e Funcionamento
  quiz2_title: "Quiz 2: Componentes e Funcionamento",
  quiz2_q1: "O que controla um drive (inversor)?",
  quiz2_q1_a: "Apenas a cor da correia",
  quiz2_q1_b: "Velocidade, direção e torque do motor",
  quiz2_q1_c: "Apenas a temperatura",

  quiz2_q2: "Que componente proporciona o movimento da correia?",
  quiz2_q2_a: "Sensor",
  quiz2_q2_b: "Motor",
  quiz2_q2_c: "Ecrã do PLC",

  quiz2_q3: "O que é desgaste mecânico?",
  quiz2_q3_a: "Um erro de software",
  quiz2_q3_b: "Desgaste normal de peças móveis que requer manutenção regular",
  quiz2_q3_c: "Uma avaria elétrica",

  quiz2_q4: "Qual é o primeiro passo no funcionamento do sistema?",
  quiz2_q4_a: "Motor arranca",
  quiz2_q4_b: "Sensor deteta uma encomenda",
  quiz2_q4_c: "Código de barras é impresso",

  quiz2_q5: "O que acontece depois do scanner ler o código de barras?",
  quiz2_q5_a: "O sistema para",
  quiz2_q5_b: "PLC determina a rota",
  quiz2_q5_c: "A encomenda é pesada",

  quiz2_q6: "O que faz o mecanismo de triagem?",
  quiz2_q6_a: "Pesar encomendas",
  quiz2_q6_b: "Direcionar encomendas para a saída correta",
  quiz2_q6_c: "Imprimir códigos de barras",

  quiz2_q7: "Que informação transmitem os sensores?",
  quiz2_q7_a: "Apenas temperatura",
  quiz2_q7_b: "Sinais para o PLC",
  quiz2_q7_c: "Apenas peso",

  quiz2_q8: "O que monitoriza continuamente o sistema?",
  quiz2_q8_a: "Apenas o tempo",
  quiz2_q8_b: "Erros e segurança",
  quiz2_q8_c: "Apenas a cor das encomendas",

  // Quiz 3 - Prática e Segurança
  quiz3_title: "Quiz 3: Prática e Segurança",
  quiz3_q1: "Qual é o primeiro passo com uma encomenda encravada?",
  quiz3_q1_a: "Puxar a encomenda com força",
  quiz3_q1_b: "Parar a máquina com segurança",
  quiz3_q1_c: "Continuar a trabalhar",

  quiz3_q2: "O que pode causar uma avaria do sensor?",
  quiz3_q2_a: "Demasiadas encomendas",
  quiz3_q2_b: "Sensor sujo, deslocado ou cabo solto",
  quiz3_q2_c: "Pouca luz na sala",

  quiz3_q3: "O que é um exemplo de avaria mecânica?",
  quiz3_q3_a: "Código de erro no ecrã",
  quiz3_q3_b: "Correia muito solta ou torta",
  quiz3_q3_c: "Ligação à internet perdida",

  quiz3_q4: "O que deve fazer com um fusível queimado?",
  quiz3_q4_a: "Ignorar e continuar a trabalhar",
  quiz3_q4_b: "Verificar e substituir o fusível",
  quiz3_q4_c: "Reiniciar o sistema sem verificar",

  quiz3_q5: "Qual é o primeiro passo no procedimento de diagnóstico?",
  quiz3_q5_a: "Entrar em pânico",
  quiz3_q5_b: "Manter a calma",
  quiz3_q5_c: "Chamar imediatamente o engenheiro",

  quiz3_q6: "O que faz um Site Engineer?",
  quiz3_q6_a: "Apenas buscar café",
  quiz3_q6_b: "Resolver problemas e realizar manutenção preventiva",
  quiz3_q6_c: "Apenas administração",

  quiz3_q7: "Que qualidade é importante para um Site Engineer?",
  quiz3_q7_a: "Impaciente",
  quiz3_q7_b: "Consciente da segurança",
  quiz3_q7_c: "Impreciso",

  quiz3_q8: "O que significa 'Medir para ter certeza'?",
  quiz3_q8_a: "Usar sempre uma fita métrica",
  quiz3_q8_b: "Testar tensão antes de trabalhar",
  quiz3_q8_c: "Pesar encomendas",

  quiz3_q9: "O que é Lock-out / Tag-out?",
  quiz3_q9_a: "Trancar a porta",
  quiz3_q9_b: "Procedimento de segurança para desligar e marcar a energia",
  quiz3_q9_c: "Um programa de computador",

  quiz3_q10: "Por que é o trabalho seguro o aspeto mais importante?",
  quiz3_q10_a: "Para trabalhar mais rápido",
  quiz3_q10_b: "Para prevenir acidentes e lesões",
  quiz3_q10_c: "Para fazer menos pausas",

  // Electrical Switching Page
  elec_title: "Comutação Elétrica",
  elec_subtitle: "Guia profissional para pessoal técnico, mecânicos e Site Engineers",

  // 1. What is electrical switching
  elec_what_title: "1. O que é Comutação Elétrica?",
  elec_what_desc: "A comutação elétrica é a abertura e fecho de circuitos elétricos para controlar o fornecimento de energia. Este é um princípio fundamental em todos os sistemas elétricos e automatizados.",
  elec_examples: "Exemplos de comutação:",
  elec_ex1: "Interruptor de luz",
  elec_ex2: "Relé",
  elec_ex3: "Contactor",
  elec_ex4: "Saída PLC",
  elec_ex5: "Botão de paragem de emergência",
  elec_ex6: "Botões Start/Stop",
  elec_closed: "Circuito Fechado",
  elec_closed_desc: "A corrente pode fluir → dispositivo funciona",
  elec_open: "Circuito Aberto",
  elec_open_desc: "Sem corrente → dispositivo está desligado",

  // 2. Basic concepts
  elec_basics_title: "2. Conceitos Básicos de Comutação",
  elec_series: "Circuito em Série",
  elec_series_desc: "Todos os interruptores devem estar fechados para a corrente fluir. Se um interruptor estiver aberto, o circuito não funciona.",
  elec_parallel: "Circuito em Paralelo",
  elec_parallel_desc: "Se um dos interruptores estiver fechado, a corrente pode fluir. Múltiplas rotas possíveis.",
  elec_no: "NO (Normally Open)",
  elec_no_desc: "Contacto normalmente aberto. Fecha apenas quando ativado (por exemplo, botão pressionado).",
  elec_nc: "NC (Normally Closed)",
  elec_nc_desc: "Contacto normalmente fechado. Abre apenas quando ativado. Frequentemente usado para segurança.",

  // 3. Types of switches
  elec_types_title: "3. Tipos de Interruptores",
  elec_type1: "Interruptor Unipolar",
  elec_type1_desc: "Liga ou desliga um circuito. Usado para aplicações simples como iluminação.",
  elec_type2: "Interruptor Bipolar",
  elec_type2_desc: "Comuta dois circuitos simultaneamente. Usado para aplicações de 230V onde fase e neutro são comutados.",
  elec_type3: "Botão de Pressão (NO/NC)",
  elec_type3_desc: "Interruptor temporário que retorna. Disponível como NO (normalmente aberto) ou NC (normalmente fechado).",
  elec_type4: "Interruptor Magnético / Contactor",
  elec_type4_desc: "Interruptor eletromagnético para correntes elevadas. Usado para motores e grandes cargas.",
  elec_type5: "Relé",
  elec_type5_desc: "Pequeno interruptor eletromagnético. Baixa corrente controla alta corrente.",
  elec_type6: "Saídas PLC",
  elec_type6_desc: "Saídas digitais do PLC que controlam outros dispositivos através de relés ou transístores.",
  elec_type7: "Interruptores de Fim de Curso",
  elec_type7_desc: "Detetam a posição de peças móveis. Frequentemente usados como limites de segurança.",
  elec_type8: "Relés de Segurança",
  elec_type8_desc: "Relés especiais para circuitos de segurança com separação forçada de contactos.",

  // 4. Industrial systems
  elec_industrial_title: "4. Comutação Elétrica em Sistemas Industriais",
  elec_industrial_desc: "Em sistemas logísticos como o BEUMER Group, a comutação elétrica é usada para:",
  elec_ind1: "Controlo de Motores",
  elec_ind1_desc: "Contactores ligam e desligam motores para transportadores. O PLC controla o contactor.",
  elec_ind2: "Circuitos Start/Stop",
  elec_ind2_desc: "Botões de pressão para operação manual. Botão Start (NO) e botão Stop (NC) em série com cadeia de segurança.",
  elec_ind3: "Circuitos de Sensores",
  elec_ind3_desc: "Sensores comutam sinais para o PLC. Fotocélulas, sensores de proximidade e scanners.",
  elec_ind4: "Cadeias de Segurança",
  elec_ind4_desc: "Contactos NC ligados em série. Se um interruptor de segurança abrir, todo o sistema para.",
  elec_ind5: "Cablagem de Paragem de Emergência",
  elec_ind5_desc: "Paragens de emergência são contactos NC na cadeia de segurança. Pressionar abre o contacto e para a máquina.",
  elec_ind6: "Deteção de Falhas via PLC",
  elec_ind6_desc: "O PLC monitoriza todos os circuitos e deteta falhas como falha de sensor ou sobrecarga do motor.",
  elec_beumer_title: "Sistemas BEUMER Group",
  elec_beumer_desc: "No BEUMER Group, são usados diagramas de circuitos complexos para controlar transportadores, sistemas de triagem e cadeias de segurança. Os Site Engineers devem ser capazes de ler estes diagramas e resolver problemas.",

  // 5. Safety
  elec_safety_title: "5. Comutação Elétrica Segura (Nível VCA)",
  elec_safety_warning: "⚠️ AVISO: A eletricidade é potencialmente fatal! Siga sempre as regras de segurança.",
  elec_safe1: "Sempre Desligar a Energia",
  elec_safe1_desc: "Desligue o interruptor principal antes de trabalhar em instalações elétricas. Verifique todas as fases.",
  elec_safe2: "Medir para Ter Certeza",
  elec_safe2_desc: "Teste sempre com um multímetro ou testador de tensão se a energia está realmente desligada. Não confie apenas nos interruptores.",
  elec_safe3: "Lock-out / Tag-out",
  elec_safe3_desc: "Bloqueie o interruptor principal com um cadeado e pendure uma etiqueta de aviso. Só você tem a chave.",
  elec_safe4: "Usar EPI",
  elec_safe4_desc: "Use equipamento de proteção individual: sapatos de segurança, luvas, óculos de segurança e ferramentas isoladas.",
  elec_safe5: "Nunca Contornar Paragens de Emergência",
  elec_safe5_desc: "Contornar paragens de emergência ou interruptores de segurança é potencialmente fatal e estritamente proibido.",
  elec_safe6: "Reconhecer Riscos",
  elec_safe6_desc: "Fique atento a cabos danificados, ligações soltas, humidade e outros perigos. Reporte situações perigosas imediatamente.",

  // 6. Common errors
  elec_errors_title: "6. Erros Comuns e Soluções",
  elec_error: "ERRO",
  elec_solution: "SOLUÇÃO",
  elec_err1: "Terminais Soltos",
  elec_err1_sol: "Verifique todos os terminais com uma chave de fendas. Aperte terminais soltos. Verifique oxidação.",
  elec_err2: "Ligação Incorreta NO/NC",
  elec_err2_sol: "Verifique o diagrama do circuito. Meça com multímetro qual contacto é NO e NC. Ligue corretamente.",
  elec_err3: "Fusível Queimado",
  elec_err3_sol: "Primeiro encontre a causa (curto-circuito, sobrecarga). Resolva o problema. Substitua o fusível com o valor correto.",
  elec_err4: "Cabo Partido",
  elec_err4_sol: "Meça a continuidade com multímetro. Substitua o cabo danificado. Verifique o encaminhamento do cabo para bordas afiadas.",
  elec_err5: "Sensor Não Funciona",
  elec_err5_sol: "Limpe o sensor. Verifique a tensão de alimentação. Teste com o display do PLC. Verifique distância e alinhamento.",
  elec_err6: "Contactor Não Aciona",
  elec_err6_sol: "Meça a tensão da bobina. Verifique a saída do PLC. Limpe os contactos. Substitua o contactor defeituoso.",

  // 7. Practice exercises
  elec_practice_title: "7. Exercícios Práticos",
  elec_practice_desc: "Teste os seus conhecimentos com estas questões práticas:",
  elec_q1: "O que acontece se um sensor NC permanecer aberto?",
  elec_q1_a: "O sistema inicia automaticamente",
  elec_q1_b: "O sistema não pode iniciar (cadeia de segurança interrompida)",
  elec_q1_c: "Nada, o sistema funciona normalmente",
  elec_q2: "O que verifica primeiro quando um motor não arranca?",
  elec_q2_a: "A cor do motor",
  elec_q2_b: "Se o motor é novo",
  elec_q2_c: "Tensão no contactor, saída do PLC, posição da paragem de emergência e fusíveis",
  elec_q3: "Por que é usado um contactor em vez de um interruptor normal?",
  elec_q3_a: "Um contactor pode comutar correntes elevadas e é controlado remotamente",
  elec_q3_b: "Um contactor é mais barato",
  elec_q3_c: "Um contactor tem melhor aparência",
  elec_check: "Verificar Respostas",
  elec_retry: "Tentar Novamente",
  elec_perfect: "Perfeito! Todas as respostas corretas!",
  elec_good: "Muito bem!",
  elec_try_again: "Tente novamente",
  elec_score_text: "Respondeu corretamente a {score} de {total} perguntas.",

  // 8. Summary
  elec_summary_title: "8. Resumo",
  elec_sum1: "A comutação elétrica é abrir e fechar circuitos para controlar a corrente",
  elec_sum2: "NO (Normally Open) fecha quando ativado, NC (Normally Closed) abre quando ativado",
  elec_sum3: "Circuito em série: todos os interruptores devem estar fechados. Circuito em paralelo: um interruptor fechado é suficiente",
  elec_sum4: "Diferentes interruptores: unipolar, bipolar, botões de pressão, contactores, relés, saídas PLC",
  elec_sum5: "Em sistemas industriais, os circuitos são usados para motores, sensores, segurança e paragens de emergência",
  elec_sum6: "A segurança é primordial: desligar energia, medir, Lock-out/Tag-out, usar EPI",
  elec_sum7: "Erros comuns: terminais soltos, ligações incorretas, fusíveis queimados, cabos partidos",
  elec_sum8: "Como Site Engineer, deve ser capaz de ler diagramas de circuitos e resolver falhas elétricas",
  elec_final_message: "A comutação elétrica é uma competência fundamental para cada Site Engineer. A segurança está sempre em primeiro lugar!",

  // Onderhoudstechniek page
  maint_title: 'Tecnologia de Manutenção',
  maint_subtitle: 'Técnicas profissionais para manutenção de sistemas logísticos, máquinas e instalações',
  
  maint_what_title: 'O que é tecnologia de manutenção?',
  maint_what_desc: 'A tecnologia de manutenção é uma área essencial focada em manter máquinas, instalações e sistemas técnicos em condições ideais. O objetivo é prevenir falhas, melhorar a confiabilidade e garantir a segurança.',
  
  maint_focus1: 'Manutenção de máquinas',
  maint_focus1_desc: 'Manutenção regular em correias transportadoras, motores, rolamentos e outros componentes mecânicos',
  maint_focus2: 'Prevenção de falhas',
  maint_focus2_desc: 'Ação proativa para prevenir defeitos antes que ocorram',
  maint_focus3: 'Melhoria da confiabilidade',
  maint_focus3_desc: 'Otimização de sistemas para máximo tempo de atividade e desempenho',
  maint_focus4: 'Trabalho seguro',
  maint_focus4_desc: 'Execução de todos os trabalhos de acordo com normas VCA e protocolos de segurança',
  
  maint_logistics_title: 'Exemplos de sistemas logísticos',
  maint_logistics_desc: 'Nos centros de triagem da PostNL, DHL e Bol.com, a tecnologia de manutenção é crucial. As correias transportadoras devem processar milhares de pacotes diariamente. A manutenção preventiva em rolamentos, rolos e sensores previne paralisações custosas e garante operação contínua.',
  
  maint_types_title: 'Tipos de manutenção',
  
  maint_preventive: 'Manutenção preventiva',
  maint_preventive_desc: 'Manutenção planeada para prevenir falhas',
  maint_prev1: 'Manutenção programada conforme plano',
  maint_prev2: 'Lubrificação de rolamentos e peças móveis',
  maint_prev3: 'Substituição de peças de desgaste',
  maint_prev4: 'Inspeções e verificações periódicas',
  
  maint_corrective: 'Manutenção corretiva',
  maint_corrective_desc: 'Reparações após uma falha ou defeito',
  maint_corr1: 'Reparações após falhas',
  maint_corr2: 'Substituição de peças defeituosas',
  maint_corr3: 'Realização de diagnóstico e resolução',
  
  maint_predictive: 'Manutenção preditiva',
  maint_predictive_desc: 'Manutenção baseada em dados de sensores e análise',
  maint_pred1: 'Análise de dados de sensores',
  maint_pred2: 'Realização de medições de vibração',
  maint_pred3: 'Monitorização de medições de temperatura',
  maint_pred4: 'Deteção precoce de falhas',
  
  maint_periodic: 'Manutenção periódica',
  maint_periodic_desc: 'Verificações regulares de acordo com cronograma fixo',
  maint_per1: 'Verificações semanais',
  maint_per2: 'Inspeções mensais',
  maint_per3: 'Manutenção geral anual',
  
  maint_components_title: 'Componentes importantes na tecnologia de manutenção',
  
  maint_comp1: 'Motores (AC/DC)',
  maint_comp1_desc: 'Acionamentos elétricos para correias transportadoras e máquinas',
  maint_comp2: 'Rolamentos',
  maint_comp2_desc: 'Rolamentos de esferas e rolos que suportam peças móveis',
  maint_comp3: 'Rolos',
  maint_comp3_desc: 'Rolos de transporte para transporte por correia',
  maint_comp4: 'Correias transportadoras',
  maint_comp4_desc: 'Correias de borracha ou plástico para transporte de mercadorias',
  maint_comp5: 'Acionamentos (inversores)',
  maint_comp5_desc: 'Controladores de frequência para controlo de motores',
  maint_comp6: 'Sensores',
  maint_comp6_desc: 'Sensores fotoelétricos, indutivos e laser',
  maint_comp7: 'Correntes e engrenagens',
  maint_comp7_desc: 'Transmissões mecânicas e acoplamentos',
  maint_comp8: 'Cablagem elétrica',
  maint_comp8_desc: 'Cabos, armários de comutação e conexões',
  
  maint_diagnosis_title: 'Diagnóstico e análise de falhas',
  maint_diagnosis_desc: 'Uma abordagem sistemática para detetar e resolver falhas:',
  
  maint_diag1: 'Leitura de códigos de erro',
  maint_diag1_desc: 'Verificar códigos de erro PLC e mensagens de alarme',
  maint_diag2: 'Inspeção visual',
  maint_diag2_desc: 'Verificar danos visíveis, desgaste ou desvios',
  maint_diag3: 'Realização de medições',
  maint_diag3_desc: 'Medir tensão, resistência e continuidade com multímetro',
  maint_diag4: 'Teste de sensores',
  maint_diag4_desc: 'Verificar operação de sensores e medir sinais',
  maint_diag5: 'Verificação de motores',
  maint_diag5_desc: 'Avaliar vibrações, temperatura e som dos motores',
  maint_diag6: 'Desmontagem de peças',
  maint_diag6_desc: 'Remover e inspecionar componentes suspeitos',
  maint_diag7: 'Registo da causa',
  maint_diag7_desc: 'Documentar falha no registo de manutenção',
  maint_diag8: 'Medidas preventivas',
  maint_diag8_desc: 'Tomar ações para prevenir recorrência',
  
  maint_procedures_title: 'Procedimentos de manutenção',
  
  maint_proc1: 'Desligamento seguro (LOTO)',
  maint_proc1_desc: 'Aplicar procedimento Lock-out/Tag-out',
  maint_proc2: 'Trabalho sem tensão',
  maint_proc2_desc: 'Desligar tensão e verificar',
  maint_proc3: 'Lubrificação de rolamentos',
  maint_proc3_desc: 'Aplicar lubrificantes corretos nos locais corretos',
  maint_proc4: 'Substituição de correias',
  maint_proc4_desc: 'Remover correia antiga e instalar correia nova',
  maint_proc5: 'Alinhamento de motores',
  maint_proc5_desc: 'Posicionar motores e rolos corretamente',
  maint_proc6: 'Tensionamento de correntes',
  maint_proc6_desc: 'Definir tensão correta de correntes e correias',
  maint_proc7: 'Limpeza e inspeção',
  maint_proc7_desc: 'Limpar e verificar máquinas',
  maint_proc8: 'Realização de verificações',
  maint_proc8_desc: 'Verificações pré e pós de acordo com checklist',
  
  maint_safety_title: 'Segurança durante a manutenção (VCA)',
  maint_safety_warning: 'A segurança tem sempre prioridade!',
  maint_safety_warning_desc: 'Todos os trabalhos de manutenção devem ser realizados de acordo com normas VCA e protocolos de segurança da empresa. Nunca corra riscos e trabalhe sempre de acordo com os procedimentos.',
  
  maint_safe1: 'Desligar tensão',
  maint_safe1_desc: 'Sempre desligar tensão primeiro antes de começar',
  maint_safe2: 'Lock-out/Tag-out',
  maint_safe2_desc: 'Aplicar e bloquear procedimento LOTO',
  maint_safe3: 'Usar EPI',
  maint_safe3_desc: 'Capacete, óculos de segurança, luvas e sapatos',
  maint_safe4: 'Avaliar riscos',
  maint_safe4_desc: 'Realizar inspeção do local de trabalho e análise de riscos',
  maint_safe5: 'Ferramentas corretas',
  maint_safe5_desc: 'Usar apenas ferramentas aprovadas e adequadas',
  maint_safe6: 'Segurança contra incêndios',
  maint_safe6_desc: 'Extintor disponível e rotas de fuga livres',
  maint_safe7: 'Proteção de máquinas',
  maint_safe7_desc: 'Respeitar proteções e não remover',
  maint_safe8: 'Sem bypasses',
  maint_safe8_desc: 'Nunca fazer bypass de circuitos de segurança',
  
  maint_problems_title: 'Problemas comuns e soluções',
  
  maint_prob1: 'Rolamentos gastos',
  maint_prob1_sol: 'Substituir rolamentos, investigar causa do desgaste (lubrificação, carga)',
  maint_prob2: 'Correia desalinhada',
  maint_prob2_sol: 'Alinhar rolos, verificar e ajustar tensão da correia',
  maint_prob3: 'Sensor defeituoso',
  maint_prob3_sol: 'Limpar sensor, verificar ajuste ou substituir sensor',
  maint_prob4: 'Quebra de cabo',
  maint_prob4_sol: 'Substituir cabo danificado, verificar fixação',
  maint_prob5: 'Motor sobreaquecido',
  maint_prob5_sol: 'Verificar arrefecimento, reduzir carga, substituir motor se necessário',
  maint_prob6: 'Terminais soltos',
  maint_prob6_sol: 'Verificar e apertar todas as conexões elétricas',
  maint_prob7: 'Contaminação na máquina',
  maint_prob7_sol: 'Limpar máquina completamente, estabelecer cronograma de limpeza preventiva',
  maint_prob8: 'Rolos quebrados',
  maint_prob8_sol: 'Substituir rolos defeituosos, investigar causa da quebra',
  maint_prob9: 'Inversor defeituoso',
  maint_prob9_sol: 'Ler códigos de erro, verificar parâmetros ou substituir inversor',
  
  maint_problem: 'Problema',
  maint_solution: 'Solução',
  maint_cause: 'Causa',
  
  maint_cases_title: 'Exemplos práticos',
  maint_cases_desc: 'Situações reais da prática com diagnóstico e soluções:',
  maint_click_details: 'Clique para detalhes',
  
  maint_case1_title: 'Motor não arranca',
  maint_case1_problem: 'Um motor de correia transportadora não responde ao sinal de arranque. O PLC não dá mensagem de erro.',
  maint_case1_cause: 'Após verificação, a proteção do motor (relé térmico) foi desligada devido a sobrecarga. A correia transportadora estava sobrecarregada com pacotes muito pesados.',
  maint_case1_solution: 'Reiniciar relé térmico, verificar carga e definir carga máxima. Preventivo: comunicar e monitorizar limite de peso.',
  
  maint_case2_title: 'Correia transportadora desvia',
  maint_case2_problem: 'A correia transportadora continua a desviar para um lado e ameaça sair dos rolos.',
  maint_case2_cause: 'Os rolos não estão montados em paralelo e a tensão da correia é desigual.',
  maint_case2_solution: 'Alinhar rolos com nível de bolha e equipamento de alinhamento laser. Definir tensão da correia uniformemente em ambos os lados. Centrar correia e realizar teste.',
  
  maint_case3_title: 'Sensor não dá sinal',
  maint_case3_problem: 'Um sensor fotoelétrico já não deteta pacotes. O LED no sensor não acende.',
  maint_case3_cause: 'A lente do sensor está contaminada por poeira e o sensor já não é suficientemente sensível.',
  maint_case3_solution: 'Limpar sensor com agentes de limpeza adequados. Verificar distância de deteção e redefinir. Estabelecer cronograma de limpeza preventiva.',
  
  maint_case4_title: 'Falha PLC: sem saída',
  maint_case4_problem: 'Uma saída PLC já não ativa um motor. O indicador PLC acende.',
  maint_case4_cause: 'O módulo de saída está defeituoso devido a um curto-circuito na cablagem.',
  maint_case4_solution: 'Localizar e reparar curto-circuito na cablagem. Substituir módulo de saída defeituoso. Verificar cablagem quanto a danos e isolamento.',
  
  maint_summary_title: 'Resumo',
  
  maint_sum1: 'A tecnologia de manutenção é essencial para operação confiável e segura de sistemas logísticos',
  maint_sum2: 'Existem quatro tipos principais de manutenção: preventiva, corretiva, preditiva e periódica',
  maint_sum3: 'O diagnóstico sistemático ajuda a resolver falhas de forma rápida e eficaz',
  maint_sum4: 'A segurança de acordo com normas VCA tem sempre prioridade absoluta',
  maint_sum5: 'O conhecimento de componentes e procedimentos é crucial para manutenção profissional',
  maint_sum6: 'Boa documentação e medidas preventivas previnem recorrência de problemas',
  
  maint_final_message: 'A manutenção profissional garante máximo tempo de atividade, segurança e eficiência nas operações logísticas!',

  // Quiz Logistiek
  quiz_logistiek_title: "Quiz – Automação Logística & Site Engineer",
  quiz_logistiek_intro: "Teste seus conhecimentos sobre sistemas logísticos automatizados, PLCs, sensores, resolução de problemas e o papel de um Site Engineer. Este quiz abrangente contém 30 questões cobrindo todos os aspectos da automação logística moderna.",
  quiz_logistiek_instructions: "Responda todas as 30 questões selecionando a resposta correta (A, B ou C). Você receberá feedback imediato sobre sua pontuação.",
  
  // Quiz Logistiek Questions
  quiz_logistiek_q1: "Qual é a função principal de um PLC na automação logística?",
  quiz_logistiek_q1_a: "Apenas controlar iluminação",
  quiz_logistiek_q1_b: "Ler sensores e controlar motores/atuadores",
  quiz_logistiek_q1_c: "Limpar a esteira transportadora",

  quiz_logistiek_q2: "Qual empresa NÃO usa sistemas de classificação automatizados?",
  quiz_logistiek_q2_a: "Uma pequena padaria",
  quiz_logistiek_q2_b: "PostNL",
  quiz_logistiek_q2_c: "DHL",

  quiz_logistiek_q3: "O que acontece quando uma fotocélula (sensor) está suja?",
  quiz_logistiek_q3_a: "O motor funciona mais rápido",
  quiz_logistiek_q3_b: "Nada muda",
  quiz_logistiek_q3_c: "Pacotes não são detectados",

  quiz_logistiek_q4: "Qual componente fornece a força motriz para uma esteira transportadora?",
  quiz_logistiek_q4_a: "Apenas os rolos",
  quiz_logistiek_q4_b: "Motor com caixa de redução",
  quiz_logistiek_q4_c: "Apenas a própria esteira",

  quiz_logistiek_q5: "O que significa 'manutenção preventiva'?",
  quiz_logistiek_q5_a: "Realizar manutenção antes que ocorra uma falha",
  quiz_logistiek_q5_b: "Apenas reparar após uma avaria",
  quiz_logistiek_q5_c: "Nunca fazer manutenção da máquina",

  quiz_logistiek_q6: "Qual procedimento de segurança você deve SEMPRE aplicar antes da manutenção?",
  quiz_logistiek_q6_a: "Apenas usar luvas",
  quiz_logistiek_q6_b: "Simplesmente começar a trabalhar",
  quiz_logistiek_q6_c: "Procedimento Lock-out/Tag-out (LOTO)",

  quiz_logistiek_q7: "O que é um sensor de proximidade?",
  quiz_logistiek_q7_a: "Um sensor que faz som",
  quiz_logistiek_q7_b: "Um sensor que detecta objetos metálicos sem contato",
  quiz_logistiek_q7_c: "Um sensor que apenas detecta luz",

  quiz_logistiek_q8: "Qual tensão você deve desligar PRIMEIRO durante manutenção elétrica?",
  quiz_logistiek_q8_a: "A tensão principal (400V)",
  quiz_logistiek_q8_b: "Apenas a tensão de controle (24V)",
  quiz_logistiek_q8_c: "Nenhuma tensão precisa ser desligada",

  quiz_logistiek_q9: "Qual é a função dos rolamentos em uma esteira transportadora?",
  quiz_logistiek_q9_a: "Aquecer a esteira",
  quiz_logistiek_q9_b: "Fazer ruído",
  quiz_logistiek_q9_c: "Permitir que os rolos girem suavemente com atrito mínimo",

  quiz_logistiek_q10: "Como você reconhece um motor defeituoso?",
  quiz_logistiek_q10_a: "Motor está frio",
  quiz_logistiek_q10_b: "Sons anormais, superaquecimento ou falha ao iniciar",
  quiz_logistiek_q10_c: "Motor funciona muito devagar",

  quiz_logistiek_q11: "O que é manutenção corretiva?",
  quiz_logistiek_q11_a: "Realizar reparos após uma falha ter ocorrido",
  quiz_logistiek_q11_b: "Apenas limpeza",
  quiz_logistiek_q11_c: "Lubrificação preventiva",

  quiz_logistiek_q12: "Quais EPIs (Equipamentos de Proteção Individual) são obrigatórios em um centro logístico?",
  quiz_logistiek_q12_a: "Apenas luvas",
  quiz_logistiek_q12_b: "Apenas sapatos de segurança",
  quiz_logistiek_q12_c: "Sapatos de segurança, capacete, óculos de segurança e luvas",

  quiz_logistiek_q13: "O que significa um contato NA (Normalmente Aberto)?",
  quiz_logistiek_q13_a: "Contato está sempre fechado",
  quiz_logistiek_q13_b: "Contato está aberto em repouso, fecha quando ativado",
  quiz_logistiek_q13_c: "Contato não funciona",

  quiz_logistiek_q14: "Qual é o primeiro passo ao diagnosticar uma falha?",
  quiz_logistiek_q14_a: "Ler códigos de erro e realizar inspeção visual",
  quiz_logistiek_q14_b: "Substituir componentes diretamente",
  quiz_logistiek_q14_c: "Reiniciar a máquina",

  quiz_logistiek_q15: "Qual é a função de um scanner de código de barras na logística?",
  quiz_logistiek_q15_a: "Pesar pacotes",
  quiz_logistiek_q15_b: "Medir temperatura",
  quiz_logistiek_q15_c: "Ler informações do pacote para classificação e rastreamento",

  quiz_logistiek_q16: "Com que frequência você deve lubrificar rolamentos?",
  quiz_logistiek_q16_a: "Nunca",
  quiz_logistiek_q16_b: "De acordo com o cronograma de manutenção (ex: mensalmente)",
  quiz_logistiek_q16_c: "Apenas quando quebram",

  quiz_logistiek_q17: "Qual é a principal tarefa de um Site Engineer?",
  quiz_logistiek_q17_a: "Resolver falhas, monitorar processos e coordenar comunicação",
  quiz_logistiek_q17_b: "Apenas tomar café",
  quiz_logistiek_q17_c: "Apenas fazer administração",

  quiz_logistiek_q18: "Qual medição você realiza para encontrar uma quebra de cabo?",
  quiz_logistiek_q18_a: "Medição de temperatura",
  quiz_logistiek_q18_b: "Medição de peso",
  quiz_logistiek_q18_c: "Medição de continuidade",

  quiz_logistiek_q19: "O que é um inversor (drive de frequência)?",
  quiz_logistiek_q19_a: "Um interruptor",
  quiz_logistiek_q19_b: "Um dispositivo que controla a velocidade do motor ajustando a frequência",
  quiz_logistiek_q19_c: "Uma lâmpada",

  quiz_logistiek_q20: "Qual procedimento você segue quando uma parada de emergência é ativada?",
  quiz_logistiek_q20_a: "Verificar causa, garantir segurança, então realizar reset",
  quiz_logistiek_q20_b: "Resetar imediatamente sem verificar",
  quiz_logistiek_q20_c: "Ignorar a parada de emergência",

  quiz_logistiek_q21: "O que é manutenção preditiva?",
  quiz_logistiek_q21_a: "Adivinhar quando a manutenção é necessária",
  quiz_logistiek_q21_b: "Apenas inspeção visual",
  quiz_logistiek_q21_c: "Planejar manutenção baseada em dados de sensores e medições",

  quiz_logistiek_q22: "Como você testa se um sensor funciona?",
  quiz_logistiek_q22_a: "Apenas olhando para ele",
  quiz_logistiek_q22_b: "Medindo sinal com multímetro ou verificando status do PLC",
  quiz_logistiek_q22_c: "Substituindo o sensor",

  quiz_logistiek_q23: "O que geralmente causa desalinhamento de esteira transportadora?",
  quiz_logistiek_q23_a: "Rolos incorretamente alinhados ou tensão desigual",
  quiz_logistiek_q23_b: "Muitos pacotes",
  quiz_logistiek_q23_c: "Cor errada da esteira",

  quiz_logistiek_q24: "Que informação você encontra em um código de erro do PLC?",
  quiz_logistiek_q24_a: "Apenas a hora",
  quiz_logistiek_q24_b: "Apenas a data",
  quiz_logistiek_q24_c: "Tipo de falha, localização e possível causa",

  quiz_logistiek_q25: "Qual é a função de um contator?",
  quiz_logistiek_q25_a: "Fazer ruído",
  quiz_logistiek_q25_b: "Comutar circuitos elétricos (ligar/desligar) remotamente",
  quiz_logistiek_q25_c: "Apenas dimmerizar luzes",

  quiz_logistiek_q26: "Como você previne que pacotes travem em uma esteira transportadora?",
  quiz_logistiek_q26_a: "Inspeção regular, ajuste adequado e manter limpo",
  quiz_logistiek_q26_b: "Empurrar mais forte",
  quiz_logistiek_q26_c: "Colocar mais pacotes nela",

  quiz_logistiek_q27: "O que significa contato NF (Normalmente Fechado)?",
  quiz_logistiek_q27_a: "Contato não funciona",
  quiz_logistiek_q27_b: "Contato está sempre aberto",
  quiz_logistiek_q27_c: "Contato está fechado em repouso, abre quando ativado",

  quiz_logistiek_q28: "Qual verificação você realiza após substituir uma esteira transportadora?",
  quiz_logistiek_q28_a: "Não verificar nada",
  quiz_logistiek_q28_b: "Verificar alinhamento, tensão e teste de funcionamento",
  quiz_logistiek_q28_c: "Apenas verificar a cor",

  quiz_logistiek_q29: "Qual é a regra mais importante durante trabalho em turnos como Site Engineer?",
  quiz_logistiek_q29_a: "Boa passagem de informações entre turnos",
  quiz_logistiek_q29_b: "Ir para casa o mais rápido possível",
  quiz_logistiek_q29_c: "Apenas fazer seu próprio trabalho",

  quiz_logistiek_q30: "Qual medição você realiza para diagnosticar problemas do motor?",
  quiz_logistiek_q30_a: "Apenas olhar para o motor",
  quiz_logistiek_q30_b: "Cheirar o motor",
  quiz_logistiek_q30_c: "Medir tensão, corrente e resistência de isolamento",

  // Quiz feedback
  quiz_progress: "Progresso",
  quiz_questions: "questões",
  quiz_expert_level: "Nível Expert Alcançado!",
  quiz_expert_message: "Excelente! Você tem muito bom conhecimento de automação logística e tarefas de Site Engineer.",
  quiz_average: "Médio - mais estudo recomendado"
};
